import gql from 'graphql-tag';

export default gql`
  fragment UserGroupFragment on UserGroup {
    _id
    type
    name
    isRemoved
    users {
      user {
        _id
        firstName
        lastName
        email
        avatar {
          path
        }
      }
    }
    data {
      course {
        _id
        title
      }
      courseCategoryProgress
      courseCategoryTotalLessons
      completeCourseCategories {
        _id
        lessonTemplate
      }
      courseCategory {
        _id
        title
        categoryIndex
      }
      lessonTemplate {
        _id
        title
      }
      teacher {
        _id
        firstName
        lastName
      }
    }
    creator {
      login
      _id
      firstName
      isActivated
      lastName
      isSubscribedToPosts
      email
      phone
      avatar {
        path
      }
      role
    }
  }
`;
